import { Fragment, useMemo } from 'react'
import get from 'lodash/get'
import Head from 'next/head'
import PropTypes from 'prop-types'

import { useTranslations } from 'common/language'
import { getOgImage } from 'common/utils/getOgImage'
import { Container, Typography } from 'common/widgets'
import {
  Content,
  HeroWithText,
} from 'common/widgets/blocks'
import classNames from './styles.module.scss'


const blocks = {
  content: Content,
  quote_section_block: HeroWithText,
}

AboutBoaView.propTypes = {
  data: PropTypes.shape({
    content: PropTypes.arrayOf(PropTypes.shape({
      type: PropTypes.string,
      value: PropTypes.object,
      id: PropTypes.string,
    })),
  }).isRequired,
  quote: PropTypes.string.isRequired,
}

export default function AboutBoaView({ data, quote }) {
  const { gettext, languageCode } = useTranslations()
  const components = useMemo(() => data.content.map(({ type, value, id }) => {
    const Component = blocks[type]
    return Component ? <Component key={id} data={value} /> : null
  }), [data.content])
  const ogImage = useMemo(() => {
    const firstImage = get(data.content, '[0].value.quote_blocks', []).find(i => i.image)
    return getOgImage({
      value: {
        image: {
          bynder: firstImage?.image?.bynder,
          data: {
            name: firstImage?.image?.data?.name,
          },
        },
      },
    })
  }, [data])
  const origin = useMemo(() => typeof window === 'undefined' ? process.env.ORIGIN_URL : window.location.origin, [])
  return (
    <Fragment>
      <Head>
        <title>{gettext('About Boa Lingua')}</title>
        <meta property="og:title" content={gettext('About Boa Lingua')} key="og-title" />
        <meta property="og:image" content={ogImage} key="og-image" />
        <meta property="og:url" content={origin + '/' + languageCode + '/quote/list/' + quote + '/quote-page'} key="og-url" />
        <meta property="og:type" content="website" key="og-type" />
        <meta name="robots" content="noindex" />
      </Head>
      <Container size="xl" className={classNames.wrapper}>
        <Typography variant="h2" className={classNames.mainTitle}>
          {gettext('About Boa Lingua')}
        </Typography>
        {components}
      </Container>
    </Fragment>
  )
}
